import { BaseError } from 'make-error'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const NAME = `NotFoundError`
const MESSAGE = `Page was not found`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

class NotFoundError extends BaseError {
  constructor() {
    super(MESSAGE)
    this.name = NAME
  }
}

export default NotFoundError
